
interface ColumnItem {
    id: number;
    name: string;
    checked: boolean;
  }


// export const initialColumnItems: ColumnItem[] = [
//     { id: 1, name: 'ID', checked: true },
//     { id: 2, name: 'Name', checked: true },
//     { id: 3, name: 'Subject', checked: true },
//     { id: 4, name: 'First Name', checked: true },
//     { id: 5, name: 'Last Name', checked: true },
//     { id: 6, name: 'Address Composite', checked: true },
//     { id: 7, name: 'Address Line 1', checked: false },
//     { id: 8, name: 'State or Province', checked: false },
//     { id: 9, name: 'Postal Code', checked: false },
//     { id: 10, name: 'Main Phone', checked: false },
//     { id: 11, name: 'Email Address', checked: false },
//     { id: 12, name: 'Method of Inquiry', checked: false },
//     { id: 13, name: 'Prospect Date', checked: false },
//     { id: 14, name: 'Lead Source', checked: false },
//     { id: 15, name: 'Lead', checked: false },
//     { id: 16, name: 'Lead Inquiry', checked: false },
//     { id: 17, name: 'Entered by', checked: false },
//     { id: 18, name: 'Lead Taker', checked: false },
//     { id: 19, name: 'Mobile Phone', checked: false },
//     { id: 20, name: 'Verified Contact', checked: false },
//     { id: 21, name: 'Verified Prospect', checked: false },
//     { id: 22, name: 'Feed Stream Context', checked: false },
//     { id: 23, name: 'Feed Stream Input Device Type', checked: false },
//     { id: 24, name: 'Feed Stream Object ID', checked: false },
//     { id: 25, name: 'Feed Stream Object Type', checked: false },
//     { id: 26, name: 'Feed Stream Operating System', checked: false },
//     { id: 27, name: 'Feed Stream Post ID', checked: false },
//     { id: 28, name: 'Feed Stream Context ID', checked: false },
//     { id: 29, name: 'Feed Stream Search Phrase', checked: false },
//     { id: 30, name: 'Feed Stream Data', checked: false },
//     { id: 31, name: 'Feed Stream Object Name', checked: false },
//     { id: 32, name: 'Feed Stream Record Identifier', checked: false },
//     { id: 33, name: 'Feed Stream Referrer', checked: false },
//     { id: 34, name: 'Feed Stream Source', checked: false },
//     { id: 35, name: 'Feed Stream Type', checked: false },
//     { id: 36, name: 'Created On', checked: false },
//     { id: 37, name: 'Created By', checked: false },
//     { id: 38, name: 'Modified By', checked: false },
//     { id: 39, name: 'Qualification Reason', checked: false },
//     { id: 40, name: 'Status', checked: false },
//     { id: 41, name: 'Sub-Status', checked: false },
//     { id: 42, name: 'Status Reason', checked: false },
//   ];
  export const initialColumnLP = [
    { id: 3, name: 'Lead Prospect Number', checked: true, key: 'recordNumber' },
    { id: 2, name: 'Lead Prospect Name', checked: true, key: 'name' }, 
    { id: 1, name: 'Subject', checked: true, key: 'lst_Subject' }, 
    { id: 4, name: 'First Name', checked: true, key: 'firstName' },
    { id: 5, name: 'Last Name', checked: true, key: 'lastName' },
    { id: 6, name: 'Assigned To', checked: true, key: 'lst_AssignedTo' },
    { id: 7, name: 'Lead Taker', checked: true, key: 'lst_LeadTaker' },
    { id: 8, name: 'Status', checked: true, key: 'lst_Status' },
    { id: 9, name: 'Created On', checked: true, key: 'createdOn' },
    { id: 10, name: 'Modified On', checked: true, key: 'modifiedOn' }, 
    { id: 11, name: 'Email Address', checked: false, key: 'emailAddress' },
    { id: 12, name: 'Method of Inquiry', checked: false, key: 'lst_MethodOfInquiry' },
    { id: 13, name: 'Prospect Date', checked: false, key: 'prospectDate' },
    { id: 14, name: 'Lead Source', checked: false, key: 'leadSource' },
    { id: 16, name: 'Lead Inquiry', checked: false, key: 'leadInquiryRecNumber' },
    { id: 17, name: 'Entered by', checked: false, key: 'lst_EnteredBy' },
    { id: 19, name: 'Mobile Phone', checked: false, key: 'mobilePhone' },
    { id: 20, name: 'Verified Contact', checked: false, key: 'lst_VerifiedContact' },
    { id: 21, name: 'Verified Prospect', checked: false, key: 'lst_VerifiedProspect' },
    { id: 22, name: 'Created By', checked: false, key: 'createdByName' }, 
    { id: 23, name: 'Modified By', checked: false, key: 'modifiedByName' }, 
    { id: 24, name: 'Qualification Reason', checked: false, key: 'lst_QualificationReasonCode' }, 

  ];
  
